import Reveal from "@/components/base/Reveal";
import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -top-40 -left-32 w-[520px] h-[520px] rounded-full bg-accent-100/40 blur-3xl" />
      <div className="pointer-events-none absolute top-24 right-0 w-[420px] h-[420px] rounded-full bg-primary-100/40 blur-3xl" />

      <div className="relative w-full px-4 md:px-10">
        <div className="mx-auto max-w-6xl py-14 md:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
            <div className="lg:col-span-7">
              <Reveal>
                <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-label tracking-[0.18em] text-primary-700">
                  <i className="ri-bookmark-2-line" />
                  章节全集 · 全文阅读 · 无删减版
                </span>
              </Reveal>

              <Reveal delay={80}>
                <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-[1.15] text-foreground-950">
                  迷人的保姆
                  <span className="mt-3 block text-xl md:text-3xl font-normal text-foreground-700">
                    全文阅读 · 无删减版章节列表
                  </span>
                </h1>
              </Reveal>

              <Reveal delay={140}>
                <p className="mt-6 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
                  这里汇总了《迷人的保姆》全书章节，提供无删减版全文阅读、txt 下载与在线看。
                  无论你想从头追更，还是直接跳读指定的某一章，都能在这里快速找到对应入口。
                </p>
              </Reveal>

              <Reveal delay={200}>
                <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                  <a
                    href="#chapters"
                    className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-book-open-line text-base" />
                    开始阅读章节
                  </a>
                  <a
                    href="#entries"
                    className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-300 px-6 py-3 text-sm font-label text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-download-2-line text-base" />
                    下载 txt 全集
                  </a>
                </div>
              </Reveal>

              <Reveal delay={260}>
                <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-y-6 border-t border-background-200/80 pt-6">
                  {heroStats.map((stat) => (
                    <div key={stat.label} className="pr-4">
                      <dd className="font-heading text-lg md:text-xl text-foreground-950">
                        {stat.value}
                      </dd>
                      <dt className="mt-1 text-xs font-label tracking-wider text-foreground-500">
                        {stat.label}
                      </dt>
                    </div>
                  ))}
                </dl>
              </Reveal>
            </div>

            <div className="lg:col-span-5">
              <Reveal delay={160} className="lg:pl-6">
                <div className="relative mx-auto w-full max-w-[340px]">
                  <div className="relative w-full h-[420px] md:h-[480px] rounded-lg overflow-hidden border border-background-300/70 bg-background-100">
                    <img
                      src="https://readdy.ai/api/search-image?query=Elegant%20literary%20novel%20book%20cover%20illustration%20depicting%20a%20graceful%20woman%20silhouette%20standing%20beside%20a%20warm%20sunlit%20window%20with%20soft%20curtains%20and%20a%20small%20potted%20plant%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20delicate%20hand-painted%20texture%2C%20minimal%20editorial%20magazine%20art%20style%2C%20vertical%20composition%2C%20refined%20and%20tasteful%2C%20soft%20natural%20light&width=768&height=1024&seq=mb-nanny-cover-01&orientation=portrait"
                      alt="迷人的保姆 小说封面插画"
                      title="迷人的保姆 全文阅读与无删减版合集"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute -bottom-4 -left-4 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                    <p className="text-xs font-label text-foreground-500">完整收录</p>
                    <p className="mt-1 font-heading text-base text-primary-700">已完结 · 1,286 章</p>
                  </div>
                  <div className="absolute -top-5 -right-5 hidden sm:flex w-16 h-16 items-center justify-center rounded-full bg-accent-500 text-accent-950 animate-float-soft">
                    <div className="text-center leading-none">
                      <span className="block font-heading text-lg">9.4</span>
                      <span className="block text-[10px] font-label">读者评分</span>
                    </div>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}